module.exports = __webpack_public_path__ + "images/134_4096.jpg";